import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SellerLogin from '../views/SellerLogin.vue'
import SellerRegister from '../views/SellerRegister.vue'
import CustomerLogin from '../views/CustomerLogin.vue'
import CustomerRegister from '../views/CustomerRegister.vue'
import SellerDashboard from '../views/SellerDashboard.vue'
import SellerDashboardHome from '../views/SellerDashboardHome.vue'
import ProductForm from '../views/ProductForm.vue'
import ProductHistory from '../views/ProductHistory.vue'
import BuyerList from '../views/BuyerList.vue'
import ChangePassword from '../views/ChangePassword.vue'
import CustomerList from '../views/CustomerList.vue'
import CustomerOrders from '../views/CustomerOrders.vue'
import CustomerAfterSales from '../views/CustomerAfterSales.vue'
import ProductBatchForm from '../views/ProductBatchForm.vue'
import SellerCategories from '../views/SellerCategories.vue'
import SellerSubCategories from '../views/SellerSubCategories.vue'
import StockLogs from '../views/StockLogs.vue'
import FavoriteProducts from '../views/FavoriteProducts.vue'
import Cart from '../views/Cart.vue'
import SellerAfterSales from '../views/SellerAfterSales.vue'
import AddressList from '../views/AddressList.vue'
import AddressForm from '../views/AddressForm.vue'
import DeliveryList from '../views/DeliveryList.vue'
import SellerManage from '../views/SellerManage.vue'
import TryOnModelManage from '../views/tryon/TryOnModelManage.vue'
import TryOnUsageStats from '../views/tryon/TryOnUsageStats.vue'
import CustomerSizeProfile from '../views/CustomerSizeProfile.vue'
import ShopProducts from '../views/ShopProducts.vue'
import SellerPromotions from '../views/SellerPromotions.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/product/:id',
    name: 'productDetail',
    component: () => import('../views/ProductDetail.vue')
  },
  {
    path: '/product/:id/en',
    name: 'productDetailEn',
    component: () => import('../views/ProductDetailEn.vue')
  },
  {
    path: '/login',
    name: 'customerLogin',
    component: CustomerLogin
  },
  {
    path: '/register',
    name: 'customerRegister',
    component: CustomerRegister
  },
  {
    path: '/seller/login',
    name: 'sellerLogin',
    component: SellerLogin
  },
  {
    path: '/seller/register',
    name: 'sellerRegister',
    component: SellerRegister
  },
  {
    path: '/seller/product/:pathMatch(.*)*',
    redirect: to => ({
      path: '/seller/dashboard/product/new',
      query: to.query
    })
  },
  {
    path: '/seller/dashboard',
    name: 'sellerDashboard',
    component: SellerDashboard,
    meta: { requiresAuth: true, role: 'seller' },
    children: [
      {
        path: '',
        name: 'sellerDashboardHome',
        component: SellerDashboardHome
      },
      {
        path: 'product/new',
        name: 'newProduct',
        component: ProductForm
      },
      {
        path: 'product/batch',
        name: 'batchProductForm',
        component: ProductBatchForm
      },
      {
        path: 'products',
        name: 'productHistory',
        component: ProductHistory
      },
      {
        path: 'buyers',
        name: 'orderManagement',
        component: BuyerList
      },
      {
        path: 'change-password',
        name: 'changePassword',
        component: ChangePassword
      },
      {
        path: 'customers',
        name: 'customerList',
        component: CustomerList
      },
      {
        path: 'categories',
        name: 'sellerCategories',
        component: SellerCategories
      },
      {
        path: 'sub-categories',
        name: 'sellerSubCategories',
        component: SellerSubCategories
      },
      {
        path: 'stock-logs',
        name: 'stockLogs',
        component: StockLogs
      },
      {
        path: 'after-sales',
        name: 'sellerAfterSales',
        component: SellerAfterSales
      },
      {
        path: 'deliveries',
        name: 'deliveryList',
        component: DeliveryList
      },
      {
        path: 'manage',
        name: 'sellerManage',
        component: SellerManage
      },
      {
        path: 'try-on/models',
        name: 'tryOnModelManage',
        component: TryOnModelManage
      },
      {
        path: 'try-on/usage',
        name: 'tryOnUsageStats',
        component: TryOnUsageStats
      },
      {
        path: 'promotions',
        name: 'sellerPromotions',
        component: SellerPromotions
      }
    ]
  },

  {
    path: '/orders',
    name: 'customerOrders',
    component: CustomerOrders,
    meta: { requiresAuth: true, role: 'customer' }
  },
  {
    path: '/after-sales',
    name: 'customerAfterSales',
    component: CustomerAfterSales,
    meta: { requiresAuth: true, role: 'customer' }
  },
  {
    path: '/notifications',
    name: 'notificationCenter',
    component: () => import('../views/NotificationCenter.vue'),
    meta: { requiresAuth: true, role: 'customer' }
  },
  {    path: '/favorites',
    name: 'favoriteProducts',
    component: FavoriteProducts,
    meta: { requiresAuth: true, role: 'customer' }
  },
  {
    path: '/cart',
    name: 'cart',
    component: Cart
  },

  {
    path: '/addresses',
    name: 'addressList',
    component: AddressList,
    meta: { requiresAuth: true, role: 'customer' }
  },
  {
    path: '/addresses/new',
    name: 'newAddress',
    component: AddressForm,
    meta: { requiresAuth: true, role: 'customer' }
  },
  {
    path: '/addresses/:id/edit',
    name: 'editAddress',
    component: AddressForm,
    meta: { requiresAuth: true, role: 'customer' }
  },
  {
    path: '/size-profile',
    name: 'customerSizeProfile',
    component: CustomerSizeProfile,
    meta: { requiresAuth: true, role: 'customer' }
  },
  {
    path: '/shop/:sellerId/products',
    name: 'shopProducts',
    component: ShopProducts
  },
  ]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫，检查是否已登录
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth) {
    const record = to.matched.find(r => r.meta.role);
    // 检查是否需要卖家登录
    if (record && record.meta.role === 'seller') {
      if (!localStorage.getItem('sellerToken')) {
        next({ name: 'sellerLogin' })
      } else {
        next()
      }
    } else {
      // 其他需要登录的页面（客户）
      if (!localStorage.getItem('customerToken')) {
        next({ name: 'customerLogin' })
      } else {
        next()
      }
    }
  } else {
    next()
  }
})

export default router